<template>
    <div>
        <div v-cloak v-show="loading">
            <div v-for="index in 5" :key="index" class="my-3 h-12 placeholder-media w-full">
                <div class="line my-2"></div>
            </div>
        </div>

        <div v-cloak v-show="!loading">
            <div v-cloak v-if="!emptyListings">
                <table class="w-full table-auto bg-white border">
                    <thead>
                        <tr>
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold">
                                Store
                            </th>
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold">
                                Product
                            </th>
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold">
                                Status
                            </th>
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold">
                                Last Price
                            </th>
                            <!-- <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold">
                                Last Check
                            </th> -->
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold hidden sm:table-cell">
                                Last Stock
                            </th>
                            <th class="px-2 py-2 text-xs uppercase text-gray-700 font-semibold hidden sm:table-cell">
                                <!-- Actions -->
                            </th>
                        </tr>
                    </thead>
                    <tbody class="rounded border-t" class2="border">
                        <listing-list-ebay v-if="category && store" :category="category" :store="store" />
                        <listing-list-item v-for="listing in listings" :key="listing.id" :listing="listing" />
                    </tbody>
                </table>
            </div>

            <div v-cloak v-else class="text-center">
                There are currently no products to show.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stocked: {},

        categoryId: {
            type: [Number, String],
        },

        storeId: {
            type: [Number, String],
        },

        limit: {
            type: [Number, String],
            default: 20
        }
    },

    data: () => ({
        listings: [],
        category: null,
        store: null,
        loading: false,
        categoryLoading: false,
        storeLoading: false
    }),

    created() {
        // Bus.$on("listingCreated", listing => {
        //     if (listing.product_id !== this.productId) return;
        //     this.listings.unshift(listing);
        // });

        this.fetchListings();
        this.fetchCategory(this.categoryId);
        this.fetchStore('ebay');
    },

    mounted() {},

    watch: {
        // listings: {
        //     handler() {},
        //     deep: true
        // }
    },

    computed: {
        emptyListings() {
            return this.listings.length == 0;
        }
    },

    methods: {
        fetchCategory(categoryId) {
            this.categoryLoading = true;

            axios.get('/api/categories/' + categoryId)
                .then(response => {
                    this.category = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.categoryLoading = false;
                });
        },

        fetchStore(storeId) {
            this.storeLoading = true;

            axios.get('/api/stores/' + storeId)
                .then(response => {
                    this.store = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.storeLoading = false;
                });
        },

        fetchListings() {
            this.loading = true;

            axios.get("/api/listings", {
                    params: {
                        // product_id : this.productId,
                        store_id   : this.storeId,
                        stocked    : this.stocked,
                        limit      : this.limit
                    }
                })
                .then(response => {
                    this.listings = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
